import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { AlertDialogModel, ConfirmDialogModel } from '../../models'

export interface DialogState {
    ConfirmDialog: ConfirmDialogModel
    AlertDialog: AlertDialogModel
}

const initialState: DialogState = {
    ConfirmDialog: {
        Show: false,
        Body: '',
    },
    AlertDialog: {
        Show: false,
        Body: '',
    },
}

export const DialogSlice = createSlice({
    name: 'dialog',
    initialState,
    reducers: {
        updateConfirm: (state, action: PayloadAction<ConfirmDialogModel>) => {
            state.ConfirmDialog = { ...action.payload }
        },
        hideConfirm: (state) => {
            state.ConfirmDialog.Show = false
            state.ConfirmDialog = { ...initialState.ConfirmDialog }
        },
        updateAlert: (state, action: PayloadAction<AlertDialogModel>) => {
            state.AlertDialog = { ...action.payload }
        },
        hideAlert: (state) => {
            state.AlertDialog.Show = false
            state.AlertDialog = { ...initialState.AlertDialog }
        },
    },
})

export const { updateConfirm, hideConfirm, updateAlert, hideAlert } = DialogSlice.actions

export default DialogSlice.reducer
